import React, {useState} from 'react';
import {Document, Page, pdfjs} from "react-pdf";
import {Button} from '@material-ui/core';
import SendIcon from '@material-ui/icons/Send';
import ZoomIn from '@material-ui/icons/ZoomIn';
import ZoomOut from '@material-ui/icons/ZoomOut'
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export const PdfRender = ({step, ...props}) => {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [zoom, setZoom] = useState(1)
  const mediatoken = localStorage.getItem('mediatoken');

  function onDocumentLoadSuccess({numPages}) {
    setNumPages(numPages);
  }

  function handlePageChange() {
    return (
      numPages > 1 ?
        <> {pageNumber < numPages ?
          <Button variant="contained" color="primary" className='float-right' onClick={() => {
            setPageNumber(pageNumber + 1);
          }}>Avançar página</Button>
          : ''}
          {pageNumber > 1 ?
            <Button variant="contained" color="primary" className='float-left' onClick={() => {
              setPageNumber(pageNumber - 1);
            }}>Voltar página</Button>
            : ''} </>
        : '')
  }
  function zoomIn(){
    let copy = zoom
    copy += 0.5
    setZoom(copy)
    console.log("zoom ", zoom)
  }
  function zoomOut(){
    let copy = zoom
    if(copy < 2){
      return
    }else{
      copy -= 0.5
      setZoom(copy)
      console.log("zoom ", zoom)
    }
  }
  return (
    <>
      
          <a target='_blank' href={step.content + '?' + mediatoken}>
              <Button variant="contained" color="secondary" size="large" endIcon={<SendIcon />}>Baixar Arquivo</Button>
          </a>
      <div style={{display: 'flex', justifyContent: 'space-around'}}>
        <Button onClick={e => zoomIn()} variant="contained" color="secondary" endIcon={<ZoomIn/>}>Aumentar zoom</Button>
        <Button onClick={e => zoomOut()} variant="contained" color="secondary" endIcon={<ZoomOut/>}>Diminuir zoom</Button>
      </div>
      <Document
        file={step.content + '?' + mediatoken}
        onLoadSuccess={onDocumentLoadSuccess}
        className="d-flex justify-content-center"
      >
        <Page pageNumber={pageNumber} scale={zoom}/>
      </Document>
      <p>Página {pageNumber} de {numPages}</p>
      {handlePageChange()}
    </>
  );
}
